import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { NotificationsSearch } from "@/features/notification-center"

// Page de Consulta de envios do notification-center (Onda 2).
export function NotificationSearchPage() {
  const { t } = useTranslation()

  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              label: t(
                "pages.notificationCenter.searchPage.breadcrumb"
              ),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 p-4 @container">
        <NotificationsSearch />
      </section>
    </main>
  )
}
